/* istanbul ignore file */
import { loadRuntimeConfig } from "./config/runtimeConfig"

// Load runtime config from static config.json before bootstrapping the app.
// This enables single build, multi-environment deployment by allowing
// config.json to be replaced per environment without rebuilding.
loadRuntimeConfig().then(() => {
  import("./bootstrap")
})
